import {useEffect, useState} from 'react';
import ImageLoader from '../../Service/Assets/ImageLoader';
import {ImageLoaderSingleton} from '../../Service/Assets/ImageLoaderSingleton';
import {AssetMetaInterface, ScrapbookClippingInterface} from '@taopix/taopix-core/dist/types/types';
import {useUiState} from '../../Components/Context/UserInterface/UserInterfaceContext';
import {AssetType} from '@taopix/taopix-core';
import axios, {AxiosHeaders} from 'axios';

const FPO_MIN = 500;

const useImageLoader = (
  asset: AssetMetaInterface | ScrapbookClippingInterface | undefined,
  type: AssetType,
  draw = true,
  max = FPO_MIN
): string => {
  const {
    state: {isSmallScreen},
  } = useUiState();
  const [loader] = useState<ImageLoader>(ImageLoaderSingleton);
  const [src, setSrc] = useState('');

  const getImage = imageUrl => {
    //get session storage token
    const theHeaders: AxiosHeaders = new AxiosHeaders();
    const bearerToken = sessionStorage.getItem('googlePhotosToken') ?? '';

    if (bearerToken !== '') {
      theHeaders.setAuthorization(`Bearer ${bearerToken}`);
    }

    return axios
      .get(imageUrl, {headers: theHeaders, responseType: 'blob'})
      .then((response: any) => {
        const reader = new window.FileReader();
        return new Promise((ok, no) => {
          reader.onload = readerEvent => {
            return ok({success: true, imgSrc: reader.result as string});
          };
          reader.readAsDataURL(response.data);
        });
      })
      .catch(error => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (!draw) {
      return;
    }

    if (!asset) {
      return;
    }

    if (AssetType.ScrapbookClipping === type) {
      return setSrc((asset as ScrapbookClippingInterface).thumbnail);
    }

    // if we are am external asset, set the source...
    if (Object.prototype.hasOwnProperty.call(asset, 'isExternal')) {
      //if we're a google image we need to use a bearer token to get image
      if (((asset as AssetMetaInterface).src ?? '').includes('googleusercontent')) {
        getImage((asset as AssetMetaInterface).src)
          .then((response: any) => {
            return setSrc(response && response.success ? response.imgSrc : 'DENIED');
          })
          .catch(error => {
            setSrc('DENIED');
          });
      }
      return setSrc((asset as AssetMetaInterface).src);
    }

    loader
      .load(asset as AssetMetaInterface, isSmallScreen, max, max)
      .then(str => setSrc(str))
      .catch(error => {}); // do nothing
  }, [asset, type, draw]);

  return !(src ?? '').includes('googleusercontent') ? src : '';
};

export default useImageLoader;
